import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMetricsCutPerf = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M38.849 9.151 24 3 9.151 9.151 3 24l6.15 14.849L24 45l14.849-6.15L45 24zM32.4 35.914 24 29.813l-8.401 6.101 3.206-9.875-8.398-6.104 10.382-.002L24 10.06l3.21 9.873 10.382.002-8.398 6.104z" }) }) })
});
export default SvgMetricsCutPerf;
